import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowedUsers } from "src/contexts"
import { useSegment } from "src/contexts/SegmentContext"
import { useUpdateDeviceSettings } from "src/hooks/deviceSettings"

export function useCreateInsights() {
  const { currentDeviceSettings } = useFollowedUsers()
  const id = currentDeviceSettings.id
  const currentInsights = currentDeviceSettings.insights

  const updateDeviceSettings = useUpdateDeviceSettings()

  const analyticsRef = useSegment()

  const createInsights = useMemo(
    () => !updateDeviceSettings ? undefined : (insights: Array<Insight>) => {
      const data = {
        id,
        insights: [
          ...currentInsights,
          ...insights,
        ],
      }

      const response = updateDeviceSettings(data)

      insights.forEach((insight) => {
        void analyticsRef.current.track(
          "Insight Tile Added",
          {
            "Tile Type": insight.key,
          },
        )
      })

      return response
    },
    [
      analyticsRef,
      id,
      currentInsights,
      updateDeviceSettings,
    ],
  )

  return createInsights
}
